import { Injectable } from '@angular/core';
import { GetTokenResponse, ConfigurationService } from '@anb/ng-auth';
import { Observable } from 'rxjs';
import { AuthorizeClient } from 'app/modules/_core/api/proxy';

@Injectable()
export class AuthConfigurationService extends ConfigurationService {
  constructor(private _authorizeClient: AuthorizeClient) {
    super();
  }

  getToken(code: string): Observable<GetTokenResponse> {
    return this._authorizeClient.getToken(code);
  }

  getSecurityPolicies(): Observable<string[]> {
    return this._authorizeClient.getSecurityPolicies();
  }
}
